import React from 'react'
import './GoogleReview.css'

const GoogleReview = () => {
    return (
        <div className='reviewbox'>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.905443621071!2d77.0247561750894!3d28.5726019756975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1b4a7fe42615%3A0xc0db48cf04729c8c!2sKanha%20WonderCraft!5e0!3m2!1sen!2sin!4v1767237538705!5m2!1sen!2sin"
                width="100%"
                height="450"
                loading="lazy"
                title="Google Map Location of Kanha WonderCraft"
                referrerPolicy="no-referrer-when-downgrade">
            </iframe>
        </div>
    )
}

export default GoogleReview